import createPersistedState from 'vuex-persistedstate'
import { default as builderUIModifiers, namespace as builderUIModifiersNamespace } from './modules/builder-ui-modifiers'
import { default as builder, namespace as builderNamespace } from './modules/builder'
import { default as contentAdapter, namespace as contentAdapterNamespace } from './modules/content-adapter'
import { default as editorStyleManager, namespace as editorStyleManagerNamespace } from './modules/editor-style-manager'
import { default as editorDeviceManager, namespace as editorDeviceManagerNamespace } from './modules/editor-device-manager'
import { default as editorLayersExpandComponents, namespace as editorLayersExpandComponentsNamespace } from './modules/editor-layers-expand-components'
import { default as editorLinkable, namespace as editorLinkableNamespace } from './modules/editor-linkable'
import { default as editorMergeFields, namespace as editorMergeFieldsNamespace } from './modules/editor-merge-fields'
import { default as editorComponentManager, namespace as editorComponentManagerNamespace } from './modules/editor-component-manager'
import { default as recentColors, namespace as recentColorsNamespace } from './modules/recent-colors'

export const namespaced = true
export const namespace = 'BuilderCore'

export const modules = {
    [builderUIModifiersNamespace]: builderUIModifiers,
    [builderNamespace]: builder,
    [contentAdapterNamespace]: contentAdapter,
    [editorStyleManagerNamespace]: editorStyleManager,
    [editorDeviceManagerNamespace]: editorDeviceManager,
    [editorLayersExpandComponentsNamespace]: editorLayersExpandComponents,
    [editorLinkableNamespace]: editorLinkable,
    [editorMergeFieldsNamespace]: editorMergeFields,
    [editorComponentManagerNamespace]: editorComponentManager,
    [recentColorsNamespace]: recentColors,
}

export const plugins = [
    createPersistedState({
        paths: [
            `${namespace}.${contentAdapterNamespace}`,
            `${namespace}.${editorLayersExpandComponentsNamespace}`,
            `${namespace}.${recentColorsNamespace}`,
        ],
        key: namespace,
    })
]

export default {namespaced, namespace, plugins, modules}
